var _clipPath, _g, _clipPath2, _g2, _path, _clipPath3, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoSmall = function SvgLogoSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.507.445h10.048v10.048H13.507z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.734.445h-8.227v10.049h10.049v-8.2c0-1.02-.816-1.849-1.822-1.849Z",
    fill: "#FFC83E"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.444.445h10.048v10.048H.444z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.493.445H2.267C1.26.445.444 1.274.444 2.295v8.199h10.049V.445Z",
    fill: "#B7B7B7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.734 23.556h-8.227V13.508h10.049v8.199c0 1.02-.816 1.85-1.822 1.85Z",
    fill: "#EFEEEE"
  })), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.444 13.508h10.048v10.048H.444z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.493 23.556H2.266c-1.006 0-1.822-.829-1.822-1.85v-8.198h10.049v10.048Z",
    fill: "#5585F3"
  }))));
};
export { SvgLogoSmall as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Y2xpcFBhdGggaWQ9ImNsaXAwIj4KICAgIDxyZWN0IHg9IjEzLjUwNzIiIHk9IjAuNDQ1MzEyIiB3aWR0aD0iMTAuMDQ4NCIgaGVpZ2h0PSIxMC4wNDg0IiAvPgogIDwvY2xpcFBhdGg+CiAgPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwKSI+CiAgICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIxLjczNDIgMC40NDUzMTJIMTMuNTA3MlYxMC40OTM5SDIzLjU1NTZWMi4yOTQ4MUMyMy41NTU2IDEuMjc0MDMgMjIuNzQwNSAwLjQ0NTMxMiAyMS43MzQyIDAuNDQ1MzEyWiIgZmlsbD0iI0ZGQzgzRSIvPgogIDwvZz4KCiAgPGNsaXBQYXRoIGlkPSJjbGlwMSI+CiAgICA8cmVjdCB4PSIwLjQ0NDQ0MyIgeT0iMC40NDUzMTIiIHdpZHRoPSIxMC4wNDg0IiBoZWlnaHQ9IjEwLjA0ODQiIC8+CiAgPC9jbGlwUGF0aD4KICA8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDEpIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTAuNDkyOCAwLjQ0NTMxMkgyLjI2NjUxQzEuMjYwMyAwLjQ0NTMxMiAwLjQ0NDI2IDEuMjc0MDMgMC40NDQyNiAyLjI5NDgxVjEwLjQ5MzlIMTAuNDkyOFYwLjQ0NTMxMloiIGZpbGw9IiNCN0I3QjciLz4KICA8L2c+CgogIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjEuNzM0MiAyMy41NTYxSDEzLjUwNzJWMTMuNTA3OEgyMy41NTU2VjIxLjcwNjdDMjMuNTU1NiAyMi43Mjc0IDIyLjc0MDUgMjMuNTU2MSAyMS43MzQyIDIzLjU1NjFaIiBmaWxsPSIjRUZFRUVFIi8+CgogIDxjbGlwUGF0aCBpZD0iY2xpcDIiPgogICAgPHJlY3QgeD0iMC40NDQ0NDMiIHk9IjEzLjUwNzgiIHdpZHRoPSIxMC4wNDg0IiBoZWlnaHQ9IjEwLjA0ODQiIC8+CiAgPC9jbGlwUGF0aD4KICA8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDIpIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTAuNDkyNyAyMy41NTYxSDIuMjY2NDFDMS4yNjAyIDIzLjU1NjEgMC40NDQxNTMgMjIuNzI3NCAwLjQ0NDE1MyAyMS43MDY3VjEzLjUwNzhIMTAuNDkyN1YyMy41NTYxWiIgZmlsbD0iIzU1ODVGMyIvPgogIDwvZz4KPC9zdmc+Cg==";